/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type ChildrenStateAnswer =
  /** 子どもがいる */
  | 'HAS_CHILDREN'
  /** 子どもがいない */
  | 'HAS_NO_CHILDREN'
  /** 回答しない */
  | 'NO_ANSWER'
  /** 未回答 */
  | 'UNANSWERED';

export type Gender =
  | 'FEMALE'
  | 'MALE'
  | 'NO_ANSWER'
  | 'OTHER';

export type PlannerEditorTableViewerFragment = { hasLineActivationProvider: boolean, profile: { childrenState: { answer: Types.ChildrenStateAnswer, children: Array<{ birthday: DateString, gender: Types.Gender }> }, address: { postalCode: string, prefecture: string, city: string, town: string } | null } };

export const PlannerEditorTableViewerFragmentDoc = gql`
    fragment PlannerEditorTableViewer on Viewer {
  hasLineActivationProvider
  profile {
    childrenState {
      answer
      children {
        birthday
        gender
      }
    }
    address {
      postalCode
      prefecture
      city
      town
    }
  }
}
    `;